import React from 'react';
import { OutOfMvpPage } from '../../../components/other-pages.jsx';
import { evaluateRouteAvailability } from '../route-availability.js';
import {
  FEATURE_INTEGRATIONS,
  FEATURE_OBSERVABILITY,
  FEATURE_REPAIRS_MODULE,
  saIsFuturePage,
  saIsMockOnlyPage,
  saIsPrototypeRoute,
  saIsRouteAllowedInMvp,
} from '../../../components/mvp-config.jsx';

/**
 * Blocks routes according to current MVP / mock / future / prototype rules.
 * Unavailable routes render OutOfMvpPage (not 404).
 */
export function RouteAvailabilityGuard({ page, showFuturePages, children }) {
  const result = evaluateRouteAvailability(page, {
    isRouteAllowedInMvp: typeof saIsRouteAllowedInMvp === 'function' ? saIsRouteAllowedInMvp : undefined,
    isMockOnlyPage: typeof saIsMockOnlyPage === 'function' ? saIsMockOnlyPage : undefined,
    isFuturePage: typeof saIsFuturePage === 'function' ? saIsFuturePage : undefined,
    isPrototypeRoute: typeof saIsPrototypeRoute === 'function' ? saIsPrototypeRoute : undefined,
    showFuturePages,
  });

  if (!result.available) {
    const title = result.reason === 'prototype'
      ? (page === 'integrations' ? 'Integrations Center' : page === 'observabilidade' ? 'Observabilidade' : 'Módulo fora do MVP')
      : 'Módulo fora do MVP';
    return <OutOfMvpPage title={title} />;
  }

  return children;
}

/** Re-export flags for tests / docs — not inventing new permission model. */
export const ROUTE_FEATURE_FLAGS = {
  FEATURE_INTEGRATIONS,
  FEATURE_OBSERVABILITY,
  FEATURE_REPAIRS_MODULE,
};
